module.exports = __webpack_public_path__ + "img/bofang.467fa304.png";